up.migrate.renamedEvent('up:app:booted', 'up:framework:booted');
if (document.querySelector('script[up-boot=manual]')) {
    up.migrate.warn('The [up-boot="manual"] attribute must be set on the <html> element');
}
